import { brandColors, productColors } from '@givebutter/util';
import * as ListItem from 'components/list-item';
import { SelectListItemProps } from 'components/select/types';
import styled, { css } from 'styled-components';

const CheckIconWrapper = styled.div<{ isSelected?: boolean }>`
    height: 1rem;
    width: 1rem;

    & svg {
        height: 100%;
        width: 100%;
        color: ${props =>
            props.isSelected ? brandColors.cobalt.primary : productColors.gray[200]};
    }
`;

const SelectListItem = styled(ListItem.Root)<SelectListItemProps<unknown, any>>`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: ${props => props.theme.gap.sm};

    ${props =>
        props.isHighlighted &&
        css`
            background-color: ${productColors.gray[200]}7f;
        `}

    ${props =>
        props.disabled &&
        css`
            cursor: not-allowed;
            pointer-events: none;
            color: ${productColors.gray[300]};
        `}
`;

export { CheckIconWrapper, SelectListItem };
